import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import AltBusinessAccountPage from './AltBusinessAccountPage';
import { dataCaptureSelectors, saveAltBusinessAccountForm } from '../../store/dataCapture';
import {
  ALT_BUSINESS_ACCOUNT_PAGE,
  WEB_BUSINESS_TERMS_CONDITIONS,
  WEB_BUSINESS_TARIFF_GUIDE,
  WEB_FSCS_INFORMATION
} from '../../utils/constants';

const AltBusinessAccountSection = ({
  bankId,
  brandId,
  saveAltBusinessAccountForm,
  getBusinessData,
  termsConditionsRef,
  tariffGuideRef,
  fscsRef
}) => {
  const [isTermsChecked, confirmationCheckboxChange] = useState(false);
  return (
    <AltBusinessAccountPage
      brandId={brandId}
      bankId={bankId}
      saveAltBusinessAccountForm={saveAltBusinessAccountForm}
      getBusinessData={getBusinessData}
      termsConditionsRef={termsConditionsRef}
      tariffGuideRef={tariffGuideRef}
      fscsRef={fscsRef}
      isTermsChecked={isTermsChecked}
      onConfirmationCheckboxChange={value => confirmationCheckboxChange(value)}
    />
  );
};

AltBusinessAccountSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveAltBusinessAccountForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveAltBusinessAccountForm
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, ALT_BUSINESS_ACCOUNT_PAGE),
  termsConditionsRef: selectors.getPdfByWebReference(state, WEB_BUSINESS_TERMS_CONDITIONS),
  tariffGuideRef: selectors.getPdfByWebReference(state, WEB_BUSINESS_TARIFF_GUIDE),
  fscsRef: selectors.getPdfByWebReference(state, WEB_FSCS_INFORMATION)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AltBusinessAccountSection);
